import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { IconRecycle } from '../../../../../../shared/icon/icon'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { useApiFormPublishAssetVersion, useApiListPublishAssetVersion } from '../../../../../../api-new/state/content'
import { ColumnDateTime, ColumnMenu, ColumnSize, ColumnText, ColumnYesNo } from '../../../../../../shared/table-builder/table-columns'
import { Menu, MenuPurge, MenuRestore } from '../../../../../../shared/menu/menu'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { Purge } from '../../../../../../shared/page/page-purge'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export const PublishAssetVersionListRecycle = () => {
  const { url } = useRouteMatch()

  const { assetID } = useParamsInt()

  const apiListPublishAssetVersion = useApiListPublishAssetVersion()

  // const roleOrgNode = useRoleOrgNode()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListPublishAssetVersion.get(`${assetID}/deleted-parent`)
  const handleDestroyed = () => apiListPublishAssetVersion.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListPublishAssetVersion.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That published asset version was already removed.'), err)
    }
    await apiListPublishAssetVersion.get(`${assetID}/deleted-parent`)
  }

  // const roleSysApp = useRoleSysApp()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconRecycle} text="recycle">
        <CardFullHeightScrollY title="recycle">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListPublishAssetVersion} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="versionCount" header="Version" />
            <ColumnDateTime field="createdAt" />
            <ColumnSize field="contentLength" header="Size" />
            <ColumnYesNo field="isCurrent" />
            <ColumnText field="uploadedBy" />
            <ColumnText field="note" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show />
                  <MenuPurge to={`${url}/purge/${row.id}`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/purge/:purgeID`}>
        <Purge useApiForm={useApiFormPublishAssetVersion} titleParam="filename" successPath={url} />
      </Route>
    </React.Fragment>
  )
}
